import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llegué al día 15 con dinero en mi cuenta por primera vez en años. Lloré de alivio. Este método es tan simple que no puedo creer que funcione tan bien.',
    name: 'María G.',
    age: 32,
    city: 'Ciudad de México'
  }, {
    quote: 'Ya no reviso mi cuenta con miedo. Antes el día 5 ya estaba contando monedas. Ahora tengo un mini fondo y duermo tranquila.',
    name: 'Carolina R.',
    age: 28,
    city: 'Bogotá'
  }, {
    quote: 'Lo mejor es que no me pide hacer cosas imposibles. Es real, es para mujeres como yo que trabajan y sostienen su hogar.',
    name: 'Valentina M.',
    age: 35,
    city: 'Lima'
  }, {
    quote: 'Mi esposo notó el cambio. Dejamos de pelear por dinero. Ahora planeamos juntos y hay paz en casa.',
    name: 'Lucía P.',
    age: 41,
    city: 'Buenos Aires'
  }, {
    quote: 'Pensé que era mala con el dinero toda mi vida. Este libro me mostró que solo necesitaba un sistema. Cambió mi mentalidad completamente.',
    name: 'Andrea S.',
    age: 26,
    city: 'Guadalajara'
  }];
  return <section className="py-20 bg-white" data-id="element-223">
      <div className="container mx-auto px-4" data-id="element-224">
        <div className="max-w-5xl mx-auto" data-id="element-225">
          <div className="text-center mb-16" data-id="element-226">
            <h2 className="text-3xl md:text-5xl font-bold text-purple-900 mb-4 font-serif" data-id="element-227">
              Mujeres Reales. Cambios Reales.
            </h2>
            <p className="text-xl text-gray-600" data-id="element-228">
              Ellas ya recuperaron su tranquilidad financiera.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-229">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-[#F5F0FF] rounded-2xl p-6 shadow-sm border border-purple-100 flex flex-col ${index === 3 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-230">
                <div className="flex gap-1 mb-4" data-id="element-231">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-232" />)}
                </div>
                <p className="text-gray-700 italic flex-grow mb-6 text-lg" data-id="element-233">
                  "{t.quote}"
                </p>
                <div className="mt-auto border-t border-purple-200 pt-4" data-id="element-234">
                  <p className="font-bold text-purple-900" data-id="element-235">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-236">
                    {t.age} años • {t.city}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}